import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ProductLine from '@afosto/app-components-react/ProductLine';

const MissingItem = ({ item, onClick }) => {
  const handleClick = () => {
    if (onClick && typeof onClick === 'function') {
      onClick(item);
    }
  };

  return (
    <Grid item xs={12}>
      <Card>
        <CardActionArea onClick={handleClick}>
          <Box px={2} py={1} display="flex" alignItems="center" justifyContent="space-between">
            <ProductLine item={item} />
            <Box ml={1}>
              <Typography variant="h6" color="secondary">
                {item?.quantity}
              </Typography>
            </Box>
          </Box>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

MissingItem.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

MissingItem.defaultProps = {
  onClick: undefined,
};

export default MissingItem;
